<script context="module">
    // Cache de configurações em memória para renderização instantânea (0ms)
    let memorySettingsCache = null;
    let memoryFeesCache = null;
    let memoryScheduleCache = null;
    let memoryTeamCache = null;
    let memoryMpStatusCache = null;
    let memorySupportCache = null;
    let hasLoadedSettingsOnce = false;
</script>

<script>
    import { onMount, onDestroy } from 'svelte';
    import {
        fetchStoreSettings,
        updateStoreSettings,
        fetchTeamMembers,
        createTeamMember,
        updateTeamMember,
        deleteTeamMember,
        fetchOperatingHours,
        updateOperatingHours,
        fetchDeliveryFees,
        createDeliveryFee,
        updateDeliveryFee,
        deleteDeliveryFee,
        toggleStorePause,
        fetchStoreMpStatus,
        getStoreMpConnectUrl,
        disconnectStoreMp,
        fetchPublicSupport,
        createComplementGroupsBatch,
        updateAiFunnel,
        getCurrentStore
    } from '../services/api';
    import { syncGroups } from '../stores/complementsStore.js';
    import { NICHE_TEMPLATES, getNicheTemplate } from '../data/nicheTemplates.js';
    import Icon from '../components/icons/Icon.svelte';

    // Sub-componentes modulares da Central de Configurações
    import SettingsReadinessBar from '../components/settings/SettingsReadinessBar.svelte';
    import NicheSelectorModal from '../components/settings/NicheSelectorModal.svelte';
    import FeeModal from '../components/settings/FeeModal.svelte';
    import TeamMemberModal from '../components/settings/TeamMemberModal.svelte';
    import TabNicheIdentity from '../components/settings/TabNicheIdentity.svelte';
    import TabDeliveryOperations from '../components/settings/TabDeliveryOperations.svelte';
    import TabPaymentsPix from '../components/settings/TabPaymentsPix.svelte';
    import TabOperatingSchedule from '../components/settings/TabOperatingSchedule.svelte';
    import TabTeamMembers from '../components/settings/TabTeamMembers.svelte';
    import TabPlanSupport from '../components/settings/TabPlanSupport.svelte';

    export let onNotify = (msg, type) => {};
    export let isWizardMode = false;
    export let onCompleteWizard = () => {};
    export let subscriptionStatus = 'active';
    export let monthlyPrice = 97.00;

    // Aba ativa (1 a 6)
    let currentTab = 1;
    let isLoading = true;
    let isSaving = false;

    // 1. Ramo & Identidade
    let businessProfile = 'hamburgueria';
    let name = '';
    let slug = '';
    let phone = '';
    let cnpj = '';
    let address = '';
    let storeLogo = '';
    let storeBanner = '';
    let primaryColor = '#EA580C';
    let instagram = '';
    let copiedCardapio = false;
    let showNicheModal = false;

    // 2. Operação & Canais
    let acceptDelivery = true;
    let acceptPickup = true;
    let acceptDineIn = true;
    let minOrderValue = 0.00;
    let defaultDeliveryFee = 7.00;
    let estimatedMinutes = 45;
    let autoAcceptOrders = false;
    let allowHalfBroto = false;
    let isPaused = false;
    let pauseUntil = null;
    let pauseReason = '';

    // Bairros & Taxas
    let deliveryFeesList = [];
    let isLoadingFees = false;
    let showFeeModal = false;
    let editingFeeId = null;
    let feeFormNeighborhood = '';
    let feeFormFee = 7.00;
    let feeFormMinutes = 45;
    let isSavingFee = false;

    // 3. Pagamentos & PIX
    let acceptPix = true;
    let acceptCard = true;
    let acceptCash = true;
    let pixKey = '';
    let pixKeyType = 'cnpj';
    let pixName = '';

    // Mercado Pago Connect
    let mpStatus = { isConnected: false, userId: null, connectedAt: null };
    let isLoadingMp = false;
    let isConnectingMp = false;
    let isDisconnectingMp = false;

    // 4. Horários de Atendimento
    let operatingSchedule = [
        { day_of_week: 1, day_name: 'Segunda-feira', open_time: '18:00', close_time: '23:30', is_closed: false },
        { day_of_week: 2, day_name: 'Terça-feira', open_time: '18:00', close_time: '23:30', is_closed: false },
        { day_of_week: 3, day_name: 'Quarta-feira', open_time: '18:00', close_time: '23:30', is_closed: false },
        { day_of_week: 4, day_name: 'Quinta-feira', open_time: '18:00', close_time: '23:30', is_closed: false },
        { day_of_week: 5, day_name: 'Sexta-feira', open_time: '18:00', close_time: '00:00', is_closed: false },
        { day_of_week: 6, day_name: 'Sábado', open_time: '18:00', close_time: '00:00', is_closed: false },
        { day_of_week: 0, day_name: 'Domingo', open_time: '18:00', close_time: '23:30', is_closed: false }
    ];
    let closedMessage = '';

    // 5. Equipe
    let teamMembers = [];
    let isLoadingTeam = false;
    let showMemberModal = false;
    let editingMemberId = null;
    let memberFormName = '';
    let memberFormRole = 'cashier';
    let memberFormPin = '';
    let memberFormEmail = '';
    let memberFormPassword = '';
    let isSavingMember = false;

    // 6. Suporte
    let supportWhatsappUrl = '';
    let isSupportAvailable = false;

    function compressBase64(dataUrl, maxW = 1000, maxH = 1000, quality = 0.85) {
        if (!dataUrl || typeof dataUrl !== 'string' || !dataUrl.startsWith('data:image')) {
            return Promise.resolve(dataUrl);
        }
        if (dataUrl.length < 150000) {
            return Promise.resolve(dataUrl);
        }
        return new Promise((resolve) => {
            const img = new Image();
            img.onload = () => {
                let w = img.width;
                let h = img.height;
                if (w > maxW || h > maxH) {
                    const ratio = Math.min(maxW / w, maxH / h);
                    w = Math.round(w * ratio);
                    h = Math.round(h * ratio);
                }
                const canvas = document.createElement('canvas');
                canvas.width = w;
                canvas.height = h;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0, w, h);
                resolve(canvas.toDataURL('image/jpeg', quality));
            };
            img.onerror = () => resolve(dataUrl);
            img.src = dataUrl;
        });
    }

    function handleStoreLogoUpload(e) {
        const file = e.target.files && e.target.files[0];
        if (!file) return;
        if (file.size > 10 * 1024 * 1024) {
            onNotify('A imagem do logo é muito pesada (máximo 10MB).', 'warning');
            return;
        }
        const reader = new FileReader();
        reader.onload = async (ev) => {
            storeLogo = await compressBase64(ev.target.result, 400, 400, 0.85);
            try {
                localStorage.setItem('matafome_store_logo', storeLogo);
                window.dispatchEvent(new Event('store-logo-changed'));
            } catch (err) {}
            onNotify('Logotipo da loja carregado com sucesso!', 'success');
        };
        reader.readAsDataURL(file);
    }

    function removeStoreLogo() {
        storeLogo = '';
        try {
            localStorage.removeItem('matafome_store_logo');
            window.dispatchEvent(new Event('store-logo-changed'));
        } catch (err) {}
        onNotify('Logotipo removido.', 'info');
    }

    function handleStoreBannerUpload(e) {
        const file = e.target.files && e.target.files[0];
        if (!file) return;
        if (file.size > 12 * 1024 * 1024) {
            onNotify('A foto de capa é muito pesada (máximo 12MB).', 'warning');
            return;
        }
        const reader = new FileReader();
        reader.onload = async (ev) => {
            storeBanner = await compressBase64(ev.target.result, 1200, 500, 0.82);
            onNotify('Foto de capa do cardápio carregada!', 'success');
        };
        reader.readAsDataURL(file);
    }

    function removeStoreBanner() {
        storeBanner = '';
        onNotify('Foto de capa removida.', 'info');
    }

    function copyCardapioUrl() {
        const origin = typeof window !== 'undefined' ? window.location.origin : 'https://app.matafome.com';
        const url = `${origin}/cardapio/${slug || 'loja'}`;
        if (navigator.clipboard) {
            navigator.clipboard.writeText(url);
            copiedCardapio = true;
            onNotify('Link do cardápio copiado para a área de transferência!', 'success');
            setTimeout(() => { copiedCardapio = false; }, 3000);
        }
    }

    // Aplicação instantânea dos dados da loja
    function applyStoreData(store) {
        if (!store) return;
        name = store.name || '';
        slug = store.slug || '';
        phone = store.phone || '';
        cnpj = store.cnpj || '';
        address = store.address || '';
        businessProfile = store.business_profile || 'hamburgueria';
        storeLogo = store.logo || localStorage.getItem('matafome_store_logo') || '';
        storeBanner = store.banner || '';
        primaryColor = store.primary_color || '#EA580C';
        instagram = store.instagram || '';
        acceptDelivery = store.accept_delivery !== undefined ? Boolean(store.accept_delivery) : true;
        acceptPickup = store.accept_pickup !== undefined ? Boolean(store.accept_pickup) : true;
        acceptDineIn = store.accept_dine_in !== undefined ? Boolean(store.accept_dine_in) : true;
        acceptPix = store.accept_pix !== undefined ? Boolean(store.accept_pix) : true;
        acceptCard = store.accept_card !== undefined ? Boolean(store.accept_card) : true;
        acceptCash = store.accept_cash !== undefined ? Boolean(store.accept_cash) : true;
        minOrderValue = store.min_order_value ? parseFloat(store.min_order_value) : 0;
        defaultDeliveryFee = store.default_delivery_fee ? parseFloat(store.default_delivery_fee) : 7.00;
        estimatedMinutes = store.estimated_minutes ? parseInt(store.estimated_minutes, 10) : 45;
        autoAcceptOrders = Boolean(store.auto_accept_orders);
        allowHalfBroto = store.allow_half_broto !== undefined ? Boolean(Number(store.allow_half_broto)) : false;
        closedMessage = store.closed_message || '';
        isPaused = Boolean(store.is_paused);
        pauseUntil = store.pause_until || null;
        pauseReason = store.pause_reason || '';
        pixKey = store.pix_key || '';
        pixKeyType = store.pix_key_type || 'cnpj';
        pixName = store.pix_name || store.name || '';
        if (store.monthly_price !== undefined && store.monthly_price !== null) {
            monthlyPrice = parseFloat(store.monthly_price) || 97.00;
        }
    }

    // Carregamento Inicial dos Dados
    async function loadStoreData() {
        if (!name) isLoading = true;
        try {
            const store = await fetchStoreSettings();
            if (store) {
                memorySettingsCache = store;
                hasLoadedSettingsOnce = true;
                applyStoreData(store);
            }
        } catch (e) {
            console.warn('[StoreSettings] Erro ao carregar dados da loja:', e);
        } finally {
            isLoading = false;
        }
    }

    async function loadDeliveryFees() {
        if (!deliveryFeesList || deliveryFeesList.length === 0) isLoadingFees = true;
        try {
            const data = await fetchDeliveryFees();
            deliveryFeesList = Array.isArray(data) ? data : [];
            memoryFeesCache = deliveryFeesList;
        } catch (e) {
            console.warn('[StoreSettings] Erro ao carregar taxas de bairros:', e);
        } finally {
            isLoadingFees = false;
        }
    }

    async function loadOperatingHours() {
        try {
            const data = await fetchOperatingHours();
            if (Array.isArray(data) && data.length > 0) {
                operatingSchedule = data.map(d => ({
                    day_of_week: d.day_of_week,
                    day_name: d.day_name,
                    open_time: (d.open_time || '18:00').substring(0, 5),
                    close_time: (d.close_time || '23:30').substring(0, 5),
                    is_closed: Boolean(d.is_closed)
                }));
                memoryScheduleCache = operatingSchedule;
            }
        } catch (e) {
            console.warn('[StoreSettings] Erro ao carregar horários:', e);
        }
    }

    async function loadTeam() {
        if (!teamMembers || teamMembers.length === 0) isLoadingTeam = true;
        try {
            const data = await fetchTeamMembers();
            teamMembers = Array.isArray(data) ? data : [];
            memoryTeamCache = teamMembers;
        } catch (e) {
            console.warn('[StoreSettings] Erro ao carregar equipe:', e);
        } finally {
            isLoadingTeam = false;
        }
    }

    async function loadMpStatus() {
        if (!mpStatus.isConnected) isLoadingMp = true;
        try {
            const res = await fetchStoreMpStatus();
            if (res) {
                mpStatus = {
                    isConnected: Boolean(res.isConnected),
                    userId: res.userId,
                    connectedAt: res.connectedAt
                };
                memoryMpStatusCache = mpStatus;
            }
        } catch (e) {
            console.warn('[StoreSettings] Erro ao verificar Mercado Pago:', e);
        } finally {
            isLoadingMp = false;
        }
    }

    async function loadPublicSupport() {
        try {
            const data = await fetchPublicSupport();
            if (data && data.whatsapp) {
                const cleanWa = String(data.whatsapp).replace(/\D/g, '');
                if (cleanWa) {
                    const text = data.message || 'Olá, preciso de suporte no sistema MataFome';
                    supportWhatsappUrl = `https://wa.me/${cleanWa}?text=${encodeURIComponent(text)}`;
                    isSupportAvailable = true;
                    memorySupportCache = { supportWhatsappUrl, isSupportAvailable };
                }
            }
        } catch (err) {
            console.warn('[StoreSettings] Erro ao carregar suporte:', err);
        }
    }

    function handleMpMessage(e) {
        if (e?.data?.type === 'MP_CONNECTED') {
            loadMpStatus();
            onNotify('Conta Mercado Pago conectada com sucesso!', 'success');
        }
    }

    onMount(() => {
        if (typeof window !== 'undefined') {
            window.addEventListener('message', handleMpMessage);
        }

        // 1. Aplicação instantânea dos dados do estabelecimento (0ms)
        const localStore = memorySettingsCache || getCurrentStore() || JSON.parse(localStorage.getItem('matafome_store') || 'null');
        if (localStore) {
            applyStoreData(localStore);
            isLoading = false;
        }
        if (memoryFeesCache) deliveryFeesList = memoryFeesCache;
        if (memoryScheduleCache) operatingSchedule = memoryScheduleCache;
        if (memoryTeamCache) teamMembers = memoryTeamCache;
        if (memoryMpStatusCache) mpStatus = memoryMpStatusCache;
        if (memorySupportCache) {
            supportWhatsappUrl = memorySupportCache.supportWhatsappUrl;
            isSupportAvailable = memorySupportCache.isSupportAvailable;
        }

        // 2. Disparo concorrente em paralelo de todas as chamadas de configuração (sem serialização waterfall)
        Promise.allSettled([
            loadStoreData(),
            loadDeliveryFees(),
            loadOperatingHours(),
            loadTeam(),
            loadMpStatus(),
            loadPublicSupport()
        ]);
    });

    onDestroy(() => {
        if (typeof window !== 'undefined') {
            window.removeEventListener('message', handleMpMessage);
        }
    });

    // Ações de Nicho & Presets
    async function handleSelectNiche({ nicheId, template, reimportComplements }) {
        businessProfile = nicheId;
        if (template) {
            primaryColor = template.themeColor || primaryColor;
        }

        // Se o usuário solicitou reimportar complementos típicos do nicho
        if (reimportComplements && template && Array.isArray(template.groups)) {
            try {
                const payloadGroups = template.groups.map((g, idx) => ({
                    name: g.name.trim(),
                    required: g.required ? 1 : 0,
                    min_choice: g.min_choice,
                    max_choice: g.max_choice,
                    free_choices: g.free_choices,
                    display_order: idx + 1,
                    items: (g.items || []).map((i, itIdx) => ({
                        name: i.name.trim(),
                        price: parseFloat(i.price || 0),
                        display_order: itIdx + 1
                    }))
                }));

                await createComplementGroupsBatch(payloadGroups);
                await syncGroups();

                // Atualiza mensagens padrão do robô do nicho
                if (template.botMessages) {
                    await updateAiFunnel({
                        welcome_message: template.botMessages.welcome || '',
                        upsell_message: template.botMessages.upsell || ''
                    }).catch(() => {});
                }

                onNotify(`Ramo atualizado para "${template.name}" e complementos importados com sucesso!`, 'success');
            } catch (err) {
                console.error('[StoreSettings] Erro ao importar complementos:', err);
                onNotify(`Ramo atualizado, mas houve erro nos complementos: ${err.message}`, 'warning');
            }
        } else {
            onNotify(`Ramo do estabelecimento alterado para "${template?.name || nicheId}". Lembre-se de salvar as alterações.`, 'info');
        }
    }

    // Ações de Pausa Emergencial
    async function handleTogglePause(paused = !isPaused, minutes = 30, reason = '') {
        try {
            const nextState = Boolean(paused);
            const res = await toggleStorePause(nextState, minutes, reason);
            isPaused = res.is_paused !== undefined ? res.is_paused : nextState;
            pauseUntil = res.pause_until || null;
            pauseReason = res.pause_reason || '';
            onNotify(res.message || (isPaused ? 'Loja pausada temporariamente.' : 'Loja reaberta com sucesso!'), isPaused ? 'warning' : 'success');
        } catch (err) {
            onNotify(`Erro ao alterar status de pausa: ${err.message}`, 'error');
        }
    }

    // Ações de Mercado Pago Connect
    async function handleConnectMp() {
        isConnectingMp = true;
        try {
            const authUrl = await getStoreMpConnectUrl();
            if (!authUrl) throw new Error('Link de autorização não disponível.');
            const popup = window.open(authUrl, 'mp_oauth_window', 'width=600,height=750');
            if (!popup) {
                window.location.href = authUrl;
                return;
            }
            const timer = setInterval(async () => {
                if (popup.closed) {
                    clearInterval(timer);
                    await loadMpStatus();
                    isConnectingMp = false;
                }
            }, 1000);
        } catch (err) {
            onNotify(`Erro ao conectar Mercado Pago: ${err.message}`, 'error');
            isConnectingMp = false;
        }
    }

    async function handleDisconnectMp() {
        if (!confirm('Deseja desconectar sua conta Mercado Pago? Os novos pedidos não terão confirmação automática via PIX até reconectar.')) {
            return;
        }
        isDisconnectingMp = true;
        try {
            await disconnectStoreMp();
            mpStatus = { isConnected: false, userId: null, connectedAt: null };
            onNotify('Mercado Pago desconectado com sucesso.', 'info');
        } catch (err) {
            onNotify(`Erro ao desconectar: ${err.message}`, 'error');
        } finally {
            isDisconnectingMp = false;
        }
    }

    // Copiar Horário para Dias Úteis
    function handleApplyWeekdaySchedule() {
        const monday = operatingSchedule.find(d => d.day_of_week === 1);
        if (!monday) return;
        operatingSchedule = operatingSchedule.map(d => {
            if ([2, 3, 4, 5].includes(d.day_of_week)) {
                return {
                    ...d,
                    open_time: monday.open_time,
                    close_time: monday.close_time,
                    is_closed: monday.is_closed
                };
            }
            return d;
        });
        onNotify('Horário de Segunda-feira copiado para Terça, Quarta, Quinta e Sexta!', 'info');
    }

    // Modal de Taxa de Bairro
    function handleOpenFeeModal(fee) {
        if (fee) {
            editingFeeId = fee.id;
            feeFormNeighborhood = fee.neighborhood;
            feeFormFee = fee.fee;
            feeFormMinutes = fee.estimated_minutes || estimatedMinutes;
        } else {
            editingFeeId = null;
            feeFormNeighborhood = '';
            feeFormFee = defaultDeliveryFee || 7.00;
            feeFormMinutes = estimatedMinutes || 45;
        }
        showFeeModal = true;
    }

    async function handleSaveFee() {
        if (!feeFormNeighborhood.trim()) {
            onNotify('O nome do bairro é obrigatório.', 'error');
            return;
        }
        isSavingFee = true;
        try {
            const payload = {
                neighborhood: feeFormNeighborhood.trim(),
                fee: parseFloat(feeFormFee || 0),
                estimated_minutes: parseInt(feeFormMinutes || estimatedMinutes || 45, 10)
            };
            if (editingFeeId) {
                await updateDeliveryFee(editingFeeId, payload);
                onNotify('Bairro atualizado com sucesso!', 'success');
            } else {
                await createDeliveryFee(payload);
                onNotify('Novo bairro cadastrado com sucesso!', 'success');
            }
            showFeeModal = false;
            await loadDeliveryFees();
        } catch (err) {
            onNotify(`Erro ao salvar bairro: ${err.message}`, 'error');
        } finally {
            isSavingFee = false;
        }
    }

    async function handleDeleteFee(fee) {
        if (!confirm(`Remover taxa diferenciada do bairro "${fee.neighborhood}"?`)) return;
        try {
            await deleteDeliveryFee(fee.id);
            onNotify(`Bairro "${fee.neighborhood}" removido.`, 'info');
            await loadDeliveryFees();
        } catch (err) {
            onNotify(`Erro ao remover bairro: ${err.message}`, 'error');
        }
    }

    // Modal de Membro da Equipe
    function handleOpenMemberModal(member) {
        if (member) {
            editingMemberId = member.id;
            memberFormName = member.name;
            memberFormRole = member.role || 'cashier';
            memberFormPin = member.pin || '';
            memberFormEmail = member.email || '';
            memberFormPassword = '';
        } else {
            editingMemberId = null;
            memberFormName = '';
            memberFormRole = 'cashier';
            memberFormPin = '';
            memberFormEmail = '';
            memberFormPassword = '';
        }
        showMemberModal = true;
    }

    async function handleSaveMember() {
        if (!memberFormName.trim()) {
            onNotify('Nome do operador é obrigatório.', 'error');
            return;
        }
        if (!memberFormPin || memberFormPin.trim().length !== 4) {
            onNotify('O PIN deve conter exatamente 4 dígitos numéricos.', 'error');
            return;
        }
        isSavingMember = true;
        try {
            const payload = {
                name: memberFormName.trim(),
                role: memberFormRole,
                pin: memberFormPin.trim(),
                email: memberFormEmail.trim() || undefined,
                password: memberFormPassword.trim() || undefined
            };
            if (editingMemberId) {
                await updateTeamMember(editingMemberId, payload);
                onNotify('Operador atualizado com sucesso!', 'success');
            } else {
                await createTeamMember(payload);
                onNotify('Novo operador adicionado à equipe!', 'success');
            }
            showMemberModal = false;
            await loadTeam();
        } catch (err) {
            onNotify(`Erro ao salvar operador: ${err.message}`, 'error');
        } finally {
            isSavingMember = false;
        }
    }

    async function handleDeleteMember(member) {
        if (member.role === 'owner') {
            onNotify('O perfil do proprietário não pode ser excluído.', 'error');
            return;
        }
        if (!confirm(`Tem certeza que deseja remover o operador "${member.name}"?`)) return;
        try {
            await deleteTeamMember(member.id);
            onNotify(`Operador "${member.name}" removido.`, 'info');
            await loadTeam();
        } catch (err) {
            onNotify(`Erro ao remover operador: ${err.message}`, 'error');
        }
    }

    // Salvar Todas as Configurações
    async function handleSaveSettings() {
        if (!name.trim()) {
            onNotify('Nome do restaurante é obrigatório.', 'error');
            currentTab = 1;
            return;
        }

        isSaving = true;
        try {
            const [optimizedLogo, optimizedBanner] = await Promise.all([
                compressBase64(storeLogo, 400, 400, 0.85),
                compressBase64(storeBanner, 1200, 500, 0.82)
            ]);

            await updateStoreSettings({
                name: name.trim(),
                slug: slug.trim(),
                phone: phone.trim(),
                cnpj: cnpj.trim(),
                address: address.trim(),
                business_profile: businessProfile,
                logo: optimizedLogo,
                banner: optimizedBanner,
                primary_color: primaryColor,
                instagram: instagram.trim(),
                accept_delivery: acceptDelivery ? 1 : 0,
                accept_pickup: acceptPickup ? 1 : 0,
                accept_dine_in: acceptDineIn ? 1 : 0,
                accept_pix: acceptPix ? 1 : 0,
                accept_card: acceptCard ? 1 : 0,
                accept_cash: acceptCash ? 1 : 0,
                min_order_value: parseFloat(minOrderValue || 0),
                default_delivery_fee: parseFloat(defaultDeliveryFee || 0),
                estimated_minutes: parseInt(estimatedMinutes || 45, 10),
                auto_accept_orders: autoAcceptOrders ? 1 : 0,
                allow_half_broto: allowHalfBroto ? 1 : 0,
                closed_message: closedMessage.trim(),
                pix_key: pixKey.trim(),
                pix_key_type: pixKeyType,
                pix_name: pixName.trim() || name.trim(),
                onboarding_completed: 1
            });

            // Salva horários de funcionamento
            if (Array.isArray(operatingSchedule) && operatingSchedule.length > 0) {
                await updateOperatingHours(operatingSchedule);
            }

            onNotify('Todas as configurações do restaurante foram salvas com sucesso!', 'success');

            if (isWizardMode && onCompleteWizard) {
                onCompleteWizard();
            }
        } catch (e) {
            onNotify(`Erro ao salvar configurações: ${e.message}`, 'error');
        } finally {
            isSaving = false;
        }
    }
</script>

<div class="settings-view">
    <!-- Header Executivo & Botão de Salvar Global -->
    <header class="settings-header">
        <div class="header-left">
            <div class="header-badge-row">
                <span class="module-badge">CONFIGURAÇÕES GERAIS</span>
                <span class="context-pill">
                    <Icon name="settings" size={12} />
                    Painel do Dono
                </span>
            </div>
            <div class="title-wrapper">
                <h1 class="view-title">Parametrização & Identidade da Loja</h1>
                <p class="view-subtitle">Gerencie o ramo da sua operação, cardápio digital, recebimentos PIX, taxas e equipe.</p>
            </div>
        </div>

        <div class="header-actions">
            <button
                type="button"
                class="btn-save-header"
                on:click={handleSaveSettings}
                disabled={isSaving}
            >
                <Icon name={isSaving ? 'refresh' : 'check'} size={15} />
                <span>{isSaving ? 'Salvando...' : 'Salvar Alterações'}</span>
            </button>
        </div>
    </header>

    <!-- Barra de Prontidão da Loja (Checklist de Abertura) -->
    <SettingsReadinessBar
        storeName={name}
        businessProfile={businessProfile}
        pixKey={pixKey}
        operatingSchedule={operatingSchedule}
        acceptDelivery={acceptDelivery}
        acceptPickup={acceptPickup}
        acceptDineIn={acceptDineIn}
        onNavigateTab={(tabNum) => currentTab = tabNum}
    />

    <!-- Navegação de Abas Moderna -->
    <nav class="settings-nav">
        <button
            type="button"
            class="nav-tab-btn {currentTab === 1 ? 'active' : ''}"
            on:click={() => currentTab = 1}
        >
            <span class="tab-num">01</span>
            <Icon name="utensils" size={16} />
            <span class="tab-label">Ramo & Identidade</span>
        </button>

        <button
            type="button"
            class="nav-tab-btn {currentTab === 2 ? 'active' : ''}"
            on:click={() => { currentTab = 2; loadDeliveryFees(); }}
        >
            <span class="tab-num">02</span>
            <Icon name="motorcycle" size={16} />
            <span class="tab-label">Entregas & Operação</span>
        </button>

        <button
            type="button"
            class="nav-tab-btn {currentTab === 3 ? 'active' : ''}"
            on:click={() => { currentTab = 3; loadMpStatus(); }}
        >
            <span class="tab-num">03</span>
            <Icon name="dollar-sign" size={16} />
            <span class="tab-label">Pagamentos & PIX</span>
        </button>

        <button
            type="button"
            class="nav-tab-btn {currentTab === 4 ? 'active' : ''}"
            on:click={() => { currentTab = 4; loadOperatingHours(); }}
        >
            <span class="tab-num">04</span>
            <Icon name="clock" size={16} />
            <span class="tab-label">Horários</span>
        </button>

        <button
            type="button"
            class="nav-tab-btn {currentTab === 5 ? 'active' : ''}"
            on:click={() => { currentTab = 5; loadTeam(); }}
        >
            <span class="tab-num">05</span>
            <Icon name="users" size={16} />
            <span class="tab-label">Equipe</span>
        </button>

        <button
            type="button"
            class="nav-tab-btn {currentTab === 6 ? 'active' : ''}"
            on:click={() => currentTab = 6}
        >
            <span class="tab-num">06</span>
            <Icon name="award" size={16} />
            <span class="tab-label">Meu Plano & Suporte</span>
        </button>
    </nav>

    <!-- Conteúdo da Aba Ativa -->
    <main class="settings-content">
        {#if isLoading}
            <div class="loading-state">
                <div class="spinner"></div>
                <p>Carregando configurações da loja...</p>
            </div>
        {:else if currentTab === 1}
            <TabNicheIdentity
                businessProfile={businessProfile}
                bind:name={name}
                bind:slug={slug}
                bind:phone={phone}
                bind:cnpj={cnpj}
                bind:address={address}
                bind:storeLogo={storeLogo}
                bind:storeBanner={storeBanner}
                bind:primaryColor={primaryColor}
                bind:instagram={instagram}
                onOpenNicheModal={() => showNicheModal = true}
                handleStoreLogoUpload={handleStoreLogoUpload}
                removeStoreLogo={removeStoreLogo}
                handleStoreBannerUpload={handleStoreBannerUpload}
                removeStoreBanner={removeStoreBanner}
                copyCardapioUrl={copyCardapioUrl}
                copiedCardapio={copiedCardapio}
            />
        {:else if currentTab === 2}
            <TabDeliveryOperations
                bind:acceptDelivery={acceptDelivery}
                bind:acceptPickup={acceptPickup}
                bind:acceptDineIn={acceptDineIn}
                bind:minOrderValue={minOrderValue}
                bind:defaultDeliveryFee={defaultDeliveryFee}
                bind:estimatedMinutes={estimatedMinutes}
                bind:autoAcceptOrders={autoAcceptOrders}
                bind:allowHalfBroto={allowHalfBroto}
                isPaused={isPaused}
                pauseUntil={pauseUntil}
                pauseReason={pauseReason}
                deliveryFeesList={deliveryFeesList}
                isLoadingFees={isLoadingFees}
                onOpenFeeModal={handleOpenFeeModal}
                onDeleteFee={handleDeleteFee}
                onTogglePause={handleTogglePause}
            />
        {:else if currentTab === 3}
            <TabPaymentsPix
                bind:pixKey={pixKey}
                bind:pixKeyType={pixKeyType}
                bind:pixName={pixName}
                bind:acceptPix={acceptPix}
                bind:acceptCard={acceptCard}
                bind:acceptCash={acceptCash}
                mpStatus={mpStatus}
                isLoadingMp={isLoadingMp}
                isConnectingMp={isConnectingMp}
                isDisconnectingMp={isDisconnectingMp}
                onConnectMp={handleConnectMp}
                onDisconnectMp={handleDisconnectMp}
            />
        {:else if currentTab === 4}
            <TabOperatingSchedule
                bind:operatingSchedule={operatingSchedule}
                bind:closedMessage={closedMessage}
                onApplyWeekdaySchedule={handleApplyWeekdaySchedule}
            />
        {:else if currentTab === 5}
            <TabTeamMembers
                teamMembers={teamMembers}
                isLoadingTeam={isLoadingTeam}
                onOpenMemberModal={handleOpenMemberModal}
                onDeleteMember={handleDeleteMember}
            />
        {:else if currentTab === 6}
            <TabPlanSupport
                subscriptionStatus={subscriptionStatus}
                monthlyPrice={monthlyPrice}
                supportWhatsappUrl={supportWhatsappUrl}
                isSupportAvailable={isSupportAvailable}
                storeName={name}
            />
        {/if}
    </main>

    <!-- Modais Flutuantes -->
    <NicheSelectorModal
        isOpen={showNicheModal}
        currentNiche={businessProfile}
        onSelectNiche={handleSelectNiche}
        onClose={() => showNicheModal = false}
    />

    <FeeModal
        isOpen={showFeeModal}
        editingFeeId={editingFeeId}
        bind:neighborhood={feeFormNeighborhood}
        bind:fee={feeFormFee}
        bind:estimatedMinutes={feeFormMinutes}
        isSaving={isSavingFee}
        onSave={handleSaveFee}
        onClose={() => showFeeModal = false}
    />

    <TeamMemberModal
        isOpen={showMemberModal}
        editingMemberId={editingMemberId}
        bind:name={memberFormName}
        bind:role={memberFormRole}
        bind:pin={memberFormPin}
        bind:email={memberFormEmail}
        bind:password={memberFormPassword}
        isSaving={isSavingMember}
        onSave={handleSaveMember}
        onClose={() => showMemberModal = false}
    />
</div>

<style>
    .settings-view {
        padding: 24px 32px;
        height: 100%;
        min-height: 100%;
        box-sizing: border-box;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        background: #F8FAFC;
        color: #0F172A;
        font-family: inherit;
    }

    .settings-header {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 20px;
        margin-bottom: 20px;
        padding-bottom: 18px;
        border-bottom: 1px solid #E2E8F0;
        flex-wrap: wrap;
    }

    .header-left {
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    .header-badge-row {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 4px;
    }

    .module-badge {
        font-size: 10px;
        font-weight: 800;
        text-transform: uppercase;
        letter-spacing: 0.6px;
        color: #FF6A00;
        background: rgba(255, 106, 0, 0.08);
        border: 1px solid rgba(255, 106, 0, 0.2);
        padding: 3px 8px;
        border-radius: 6px;
    }

    .context-pill {
        display: inline-flex;
        align-items: center;
        gap: 5px;
        font-size: 11px;
        font-weight: 600;
        color: #475569;
        background: #F1F5F9;
        border: 1px solid #E2E8F0;
        padding: 3px 9px;
        border-radius: 9999px;
    }

    .view-title {
        font-size: 22px;
        font-weight: 800;
        color: #020617;
        margin: 0;
        letter-spacing: -0.4px;
        line-height: 1.25;
    }

    .view-subtitle {
        font-size: 13px;
        color: #64748B;
        margin: 4px 0 0 0;
        line-height: 1.4;
        max-width: 720px;
    }

    .btn-save-header {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        background: #FF6A00;
        color: #FFFFFF;
        border: 1px solid #EA580C;
        padding: 10px 22px;
        border-radius: 8px;
        font-size: 13px;
        font-weight: 700;
        cursor: pointer;
        transition: all 0.15s ease;
        box-shadow: 0 1px 3px rgba(255, 106, 0, 0.25);
    }

    .btn-save-header:hover:not(:disabled) {
        background: #EA580C;
        box-shadow: 0 3px 8px rgba(255, 106, 0, 0.35);
        transform: translateY(-1px);
    }

    .btn-save-header:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }

    /* Navegação das Abas em Segmented Control Clean */
    .settings-nav {
        display: inline-flex;
        gap: 6px;
        background: #FFFFFF;
        padding: 6px;
        border-radius: 12px;
        border: 1px solid #E2E8F0;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
        margin-bottom: 24px;
        overflow-x: auto;
        max-width: 100%;
        -webkit-overflow-scrolling: touch;
    }

    .nav-tab-btn {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        background: transparent;
        border: 1px solid transparent;
        padding: 8px 14px;
        border-radius: 8px;
        font-size: 13px;
        font-weight: 600;
        color: #475569;
        cursor: pointer;
        transition: all 0.15s ease;
        white-space: nowrap;
    }

    .nav-tab-btn:hover {
        background: #F8FAFC;
        color: #0F172A;
    }

    .nav-tab-btn.active {
        background: #FF6A00;
        color: #FFFFFF;
        border-color: #EA580C;
        box-shadow: 0 2px 6px rgba(255, 106, 0, 0.25);
    }

    .tab-num {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        border-radius: 5px;
        background: #F1F5F9;
        color: #475569;
        font-size: 10px;
        font-weight: 800;
        transition: all 0.15s ease;
    }

    .nav-tab-btn.active .tab-num {
        background: rgba(255, 255, 255, 0.25);
        color: #FFFFFF;
    }

    .tab-label {
        font-size: 13px;
    }

    .settings-content {
        min-height: 400px;
        padding-bottom: 40px;
    }

    .loading-state {
        text-align: center;
        padding: 60px 20px;
        color: #64748B;
    }

    .spinner {
        width: 32px;
        height: 32px;
        border: 3px solid #E2E8F0;
        border-top-color: #FF6A00;
        border-radius: 50%;
        animation: spin 0.8s linear infinite;
        margin: 0 auto 12px auto;
    }

    @keyframes spin {
        to { transform: rotate(360deg); }
    }
</style>
